import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import * as gql from '../gql'

/** Keeps independent zone requests alive across selection changes. */
export const executeGet = store.effects.create((feature: Feature) =>
  feature.actions.get.request.observe().pipe(
    rxjs.mergeMap(action =>
      gql.queries.apps.execute(action.data).pipe(
        rxjs.map(response =>
          feature.actions.get.success.from(action).create({
            request: action.data,
            response,
          }),
        ),
        rxjs.catchError((error: Error) =>
          rxjs.of(
            feature.actions.get.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      ),
    ),
  ),
)
